import { Language } from '@nx-smartmonkey/shared/domain';

import { PlannerCredentials } from '../../domain/credentials/PlannerCredentials';
import { User } from '../../domain/user/User';
import { UserActionType, UserActions } from './actions';

export interface UserState {
  user?: User;
  adminUser?: User;
  language: Language;
  userCountryLocation?: {
    latitude: number;
    longitude: number;
    country: string;
    mapZoomLevel?: number;
  };
  credentials?: PlannerCredentials;
}

export const getInitialState = (): UserState => {
  return {
    user: undefined,
    adminUser: undefined,
    language: Language.create(`en`),
    userCountryLocation: undefined,
    credentials: undefined,
  };
};

export const UserReducer = (state: UserState, action: UserActions): UserState => {
  switch (action.type) {
    case UserActionType.FETCH_ADMIN_USER_SUCCESS:
      return {
        ...state,
        adminUser: action.payload.adminUser,
      };
    case UserActionType.FETCH_USER_SUCCESS:
    case UserActionType.UPDATE_USER_SUCCESS:
      return { ...state, user: action.payload.user };
    case UserActionType.FETCH_USER_CREDENTIALS_SUCCESS:
      return { ...state, credentials: action.payload.credentials };
    case UserActionType.RESET_USER:
      return getInitialState();
    default:
      return state;
  }
};
